/* New Best Seller */
window.initializeNewBestSeller = function () {
  var swiper = new Swiper('.best_seller_section_data', {
    slidesPerView: 1.15,
    spaceBetween: 15,
    navigation: {
      nextEl: '.best_forward',
      prevEl: '.best_backword',
    },
    breakpoints: {
      640: {
        slidesPerView: 2.15
      },
      768: {
        // slidesPerView: "auto"
        slidesPerView: 2.15,
        spaceBetween: 20,
      },
      1024: {
        // slidesPerView: "auto"
        slidesPerView: 3.15,
        spaceBetween: 15,
      },
      1280: {
        // slidesPerView: "auto"
        slidesPerView: 4.15,
        spaceBetween: 20,
      }
    }
  });
};

// Call the function when the page loads
document.addEventListener("DOMContentLoaded", function () {
  window.initializeNewBestSeller();
});



/* Best Seller Add to Cart */


  $(document).on("click", ".bestseller_renew", function () {
  var $button = $(this);
  var productid = $(this).data("id");
  var product_qty = $(this).data("product-qty");
  $button.find(".loading__spinner").removeClass("hidden");
  $button.find(".quick_buy").addClass("no_visibility");
  if (productid) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: productid,
        quantity: product_qty,
      },
      dataType: "json",
      success: function (response) {
        console.log("Product added to cart:", response);
        $(".drawer__inner").load("/cart .drawer__inner > *", function () {
          $(".drawer").addClass("active");
          $(".drawer").removeClass("is-empty");
          $(".cart-count-bubble").load(location.href + " .cart-count-bubble");
          $button.find(".loading__spinner").addClass("hidden");
          $button.find(".quick_buy").removeClass("no_visibility");
          window.initializeCartAddOnSwiper();
        });
          // window.location.href = "/cart";
      },
      error: function (xhr, status, error) {
        console.error("Error adding product to cart:", xhr.responseText);
        $button.find(".loading__spinner").addClass("hidden");
        $button.find(".quick_buy").removeClass("no_visibility");
        try {
        const response = JSON.parse(xhr.responseText);
        if (response && response.message) {
          showATCErrorPopup(response.message);
          $button.find(".quick_buy").removeClass("no_visibility");
        }
      } catch (e) {
        showATCErrorPopup("Something went wrong. Please try again.");
         $button.find(".quick_buy").removeClass("no_visibility");
      }
      },
    });
  } else {
    console.log("Product ID not found.");
    $button.find(".loading__spinner").addClass("hidden");
    $button.find(".quick_buy").removeClass("no_visibility");
  }
});


/* Best Seller Add to Cart */


